import axios from "axios";
import store from "../context/index";
import { signout } from "../actions/auth_action";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch(signout());
    }
    return Promise.reject(error);
  }
);
